import React, { useEffect, useState } from "react";
import { useAuth } from "../../../hooks/GlobalProvider";
import { API_KEY, CRUDadmin } from "../../../hooks/APIHooks";
import { useNavigate } from "react-router-dom";

const PASSWORD = "123456789";

function NewUsers() {
  const { user } = useAuth();
  const [users, setUsers] = useState([]);
  const [payments, setPayments] = useState({}); // Store payments by user_id
  const [bankAccounts, setBankAccounts] = useState({}); // Store bank accounts by user_id
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const pageSize = 50;

  const [editingUserId, setEditingUserId] = useState(null);
  const [editFormData, setEditFormData] = useState({
    name: "",
    password: "",
    phonenumber: "",
  });

  const startEdit = (u) => {
    const enteredPassword = prompt("Enter password to confirm edit:");
    if (enteredPassword !== PASSWORD) {
      alert("Incorrect password. Action cancelled.");
      return;
    }
    setEditingUserId(u.user_id);
    setEditFormData({
      name: u.name || "",
      password: u.password || "",
      phonenumber: u.phonenumber || "",
    });
  };

  const cancelEdit = () => {
    setEditingUserId(null);
  };

  const saveUserEdit = async (user_id) => {
    try {
      const response = await fetch(
        `${CRUDadmin}?table=users&id=${user_id}&api_key=${API_KEY}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            name: editFormData.name,
            password: editFormData.password,
            phonenumber: editFormData.phonenumber,
          }),
        }
      );

      const result = await response.json();

      if (result.success) {
        alert("User details updated successfully!");
        setUsers((prevUsers) =>
          prevUsers.map((u) =>
            u.user_id === user_id
              ? {
                  ...u,
                  name: editFormData.name,
                  password: editFormData.password,
                  phonenumber: editFormData.phonenumber,
                }
              : u
          )
        );
        setEditingUserId(null);
      } else {
        alert("Failed to update user: " + result.message);
      }
    } catch (err) {
      alert("Error updating user: " + err.message);
    }
  };

  useEffect(() => {
    if (user && user.role === "admin") {
      const fetchData = async () => {
        try {
          // Fetch users
          const usersResponse = await fetch(
            `${CRUDadmin}?table=users&api_key=${API_KEY}`,
            {
              method: "GET",
              headers: { "Content-Type": "application/json" },
            }
          );

          const usersData = await usersResponse.json();

          if (usersData.success && Array.isArray(usersData.data)) {
            setUsers(usersData.data);

            // Fetch payments for all users
            const paymentsResponse = await fetch(
              `${CRUDadmin}?table=payments&api_key=${API_KEY}`,
              {
                method: "GET",
                headers: { "Content-Type": "application/json" },
              }
            );

            const paymentsData = await paymentsResponse.json();

            if (paymentsData.success && Array.isArray(paymentsData.data)) {
              // Group payments by user_id
              const paymentsByUser = {};
              paymentsData.data.forEach((payment) => {
                if (!paymentsByUser[payment.user_id]) {
                  paymentsByUser[payment.user_id] = [];
                }
                paymentsByUser[payment.user_id].push(payment);
              });
              setPayments(paymentsByUser);
            }

            // Fetch bank accounts for all users
            const bankAccountsResponse = await fetch(
              `${CRUDadmin}?table=user_bank_account&api_key=${API_KEY}`,
              {
                method: "GET",
                headers: { "Content-Type": "application/json" },
              }
            );

            const bankAccountsData = await bankAccountsResponse.json();

            if (
              bankAccountsData.success &&
              Array.isArray(bankAccountsData.data)
            ) {
              // Group bank accounts by user_id
              const bankAccountsByUser = {};
              bankAccountsData.data.forEach((account) => {
                if (!bankAccountsByUser[account.user_id]) {
                  bankAccountsByUser[account.user_id] = account;
                }
              });
              setBankAccounts(bankAccountsByUser);
            }
          } else {
            setError("Failed to fetch data");
          }
        } catch (error) {
          setError("Error fetching data: " + error.message);
        } finally {
          setLoading(false);
        }
      };
      fetchData();
    } else {
      setError("Unauthorized access");
      setLoading(false);
    }
  }, [user]);

  const togglePannelAccess = async (user_id, currentAccess) => {
    if (currentAccess === "True") return;

    const newAccess = "True";

    try {
      const response = await fetch(
        `${CRUDadmin}?table=users&id=${user_id}&api_key=${API_KEY}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ pannel_access: newAccess }),
        }
      );

      const result = await response.json();

      if (result.success) {
        setUsers((prevUsers) =>
          prevUsers.map((u) =>
            u.user_id === user_id ? { ...u, pannel_access: newAccess } : u
          )
        );
      } else {
        alert("Failed to update access");
      }
    } catch (err) {
      alert("Error updating access: " + err.message);
    }
  };

// ✅ Delete User with password check
const deleteUser = async (user_id) => {
  const confirmDelete = window.confirm("Are you sure you want to delete this user?");
  if (!confirmDelete) return;

  const enteredPassword = prompt("Enter password to confirm deletion:");
  if (enteredPassword !== PASSWORD) {
    alert("Incorrect password. Deletion cancelled.");
    return;
  }

  try {
    const response = await fetch(
      `${CRUDadmin}?table=users&id=${user_id}&api_key=${API_KEY}`,
      {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
      }
    );

    const result = await response.json();

    if (result.success) {
      alert("User deleted successfully");
      setUsers((prevUsers) => prevUsers.filter((u) => u.user_id !== user_id));
    } else {
      alert("Failed to delete user: " + result.message);
    }
  } catch (err) {
    alert("Error deleting user: " + err.message);
  }
};




  const toggleAllowEdit = async (user_id) => {
    const currentAllowEdit = bankAccounts[user_id]?.allow_edit;
    const newAllowEdit = !currentAllowEdit;

    try {
      const response = await fetch(
        `${CRUDadmin}?table=user_bank_account&id=${bankAccounts[user_id].id}&api_key=${API_KEY}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ allow_edit: newAllowEdit }),
        }
      );

      const result = await response.json();

      if (result.success) {
        setBankAccounts((prevAccounts) => ({
          ...prevAccounts,
          [user_id]: { ...prevAccounts[user_id], allow_edit: newAllowEdit },
        }));
      } else {
        alert("Failed to update allow edit status");
      }
    } catch (err) {
      alert("Error updating allow edit status: " + err.message);
    }
  };

  const filteredUsers = users.filter((u) =>
    u.phonenumber?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const paginatedData = React.useMemo(() => {
    const start = currentPage * pageSize;
    return filteredUsers.slice(start, start + pageSize);
  }, [filteredUsers, currentPage]);

  return (
    <div className="p-4 mb-16">
      <h1 className="text-2xl font-bold text-center text-white">All Users</h1>
      <div className="mb-4">
        <input
          type="text"
          placeholder="Search by phone number"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
        />
      </div>
      {error && <p className="text-red-500">{error}</p>}
      {loading ? (
        <p>Loading...</p>
      ) : (
        <div>
          <div className="overflow-x-auto sm:overflow-hidden shadow rounded-lg">
            <table className="min-w-full bg-white border border-gray-200 text-sm w-full">
              <thead className="bg-gray-100">
                <tr>
                  <th className="px-2 py-1 text-left font-medium text-gray-700 text-xs">
                    ID/Name
                  </th>
                  <th className="px-2 py-1 text-left font-medium text-gray-700 text-xs">
                    Details
                  </th>

                  <th className="px-2 py-1 text-left font-medium text-gray-700 text-xs">
                    Pannel Activate
                  </th>

                  <th className="px-2 py-1 text-left font-medium text-gray-700 text-xs">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {paginatedData.map((u) => (
                  <tr key={u.user_id} className="hover:bg-gray-100">
                    {editingUserId === u.user_id ? (
                      <>
                        <td className="px-2 py-1 text-left text-xs space-y-1">
                          <div>
                            <span className="font-bold">{u.user_id} - </span>
                            <input
                              type="text"
                              value={editFormData.name}
                              onChange={(e) =>
                                setEditFormData((prev) => ({
                                  ...prev,
                                  name: e.target.value,
                                }))
                              }
                              className="px-1 py-0.5 border border-gray-300 rounded text-black font-semibold bg-white inline-block max-w-[140px]"
                            />
                          </div>
                          <div className="bg-secondary rounded-sm pl-2 py-0.5 text-primary font-semibold flex items-center space-x-1">
                            <span>password: </span>
                            <input
                              type="text"
                              value={editFormData.password}
                              onChange={(e) =>
                                setEditFormData((prev) => ({
                                  ...prev,
                                  password: e.target.value,
                                }))
                              }
                              className="px-1 py-0.5 border border-gray-300 rounded text-black font-semibold bg-white inline-block max-w-[120px]"
                            />
                          </div>
                          <div className="pl-2 pt-1 text-primary font-semibold flex items-center space-x-2">
                            <span className="w-20 px-1 rounded text-black">
                              {u.digital_currency}
                            </span>
                          </div>
                          <div>
                            {payments[u.user_id] &&
                              payments[u.user_id].length > 0 && (
                                <div className="mt-1 pl-2 border-l-2 border-gray-200">
                                  {payments[u.user_id].map((payment, index) => (
                                    <div
                                      key={index}
                                      className="text-xs text-gray-600"
                                    >
                                      {payment.transaction_id} (₹{payment.amount})
                                    </div>
                                  ))}
                                </div>
                              )}
                          </div>
                        </td>
                        <td className="px-2 py-1 text-left text-xs space-y-1">
                          <div className="flex items-center space-x-1">
                            <span className="font-semibold">Phone: </span>
                            <input
                              type="text"
                              value={editFormData.phonenumber}
                              onChange={(e) =>
                                setEditFormData((prev) => ({
                                  ...prev,
                                  phonenumber: e.target.value,
                                }))
                              }
                              className="px-1 py-0.5 border border-gray-300 rounded text-black bg-white inline-block max-w-[120px]"
                            />
                          </div>
                          <div>{u.address || "N/A"}</div>
                        </td>
                      </>
                    ) : (
                      <>
                        <td className="px-2 py-1 text-left text-xs">
                          {u.user_id} - {u.name}
                          <p className="bg-secondary rounded-sm pl-2 text-primary font-semibold">
                            password: {u.password}
                          </p>
                          <div className="pl-2 pt-2 text-primary font-semibold flex items-center space-x-2">
                            <span className="w-20 px-1 rounded text-black">
                              {u.digital_currency}
                            </span>
                          </div>

                          <p>
                            {payments[u.user_id] &&
                              payments[u.user_id].length > 0 && (
                                <div className="mt-1 pl-2 border-l-2 border-gray-200">
                                  {payments[u.user_id].map((payment, index) => (
                                    <div
                                      key={index}
                                      className="text-xs text-gray-600"
                                    >
                                      {payment.transaction_id} (₹{payment.amount})
                                    </div>
                                  ))}
                                </div>
                              )}
                          </p>
                        </td>
                        <td className="px-2 py-1 text-left text-xs">
                          <div>{u.phonenumber || "N/A"}</div>
                          <div>{u.address || "N/A"}</div>
                        </td>
                      </>
                    )}

                    <td className="px-2 py-1 text-left text-xs">
                      {u.pannel_access === "True" ? (
                        <span className="text-green-600 font-bold">True</span>
                      ) : (
                        <span
                          onClick={() =>
                            togglePannelAccess(u.user_id, u.pannel_access)
                          }
                          className="text-red-500 font-bold cursor-pointer hover:underline"
                        >
                          Activate
                        </span>
                      )}

                      <div className="text-[10px]">
                        Allow Bank
                        <div>
                          <span
                            onClick={() => toggleAllowEdit(u.user_id)}
                            className={`font-bold cursor-pointer hover:underline ${
                              bankAccounts[u.user_id]?.allow_edit
                                ? "text-green-600"
                                : "text-red-500"
                            }`}
                          >
                            {bankAccounts[u.user_id]?.allow_edit ? "Yes" : "No"}
                          </span>
                        </div>
                      </div>
                    </td>

                    <td className="px-2 py-1 text-left text-xs">
                      {editingUserId === u.user_id ? (
                        <div className="flex flex-col space-y-1">
                          <button
                            onClick={() => saveUserEdit(u.user_id)}
                            className="px-2 py-1 bg-green-600 text-white text-xs rounded hover:bg-green-700 font-semibold"
                          >
                            Save
                          </button>
                          <button
                            onClick={cancelEdit}
                            className="px-2 py-1 bg-gray-500 text-white text-xs rounded hover:bg-gray-600"
                          >
                            Cancel
                          </button>
                        </div>
                      ) : (
                        <div className="flex flex-col space-y-1">
                          <button
                            onClick={() => startEdit(u)}
                            className="px-2 py-1 bg-blue-500 text-white text-xs rounded hover:bg-blue-600 font-semibold"
                          >
                            Edit
                          </button>
                          {u.pannel_access !== "True" && (
                            <button
                              onClick={() => deleteUser(u.user_id)}
                              className="px-2 py-1 bg-red-500 text-white text-xs rounded hover:bg-red-700"
                            >
                              Delete
                            </button>
                          )}
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {filteredUsers.length === 0 && (
            <p className="text-center mt-2">No users found.</p>
          )}
          <div className="flex justify-between items-center mt-4 space-x-4">
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 0))}
              disabled={currentPage === 0}
              className="p-2 bg-yellow-300 rounded-md disabled:opacity-50 hover:bg-yellow-500"
            >
              Previous
            </button>
            <span className="flex-grow text-center text-[12px] sm:text-base">
              Page {currentPage + 1} of{" "}
              {Math.ceil(filteredUsers.length / pageSize)}
            </span>
            <button
              onClick={() =>
                setCurrentPage((prev) =>
                  Math.min(
                    prev + 1,
                    Math.ceil(filteredUsers.length / pageSize) - 1
                  )
                )
              }
              disabled={
                currentPage === Math.ceil(filteredUsers.length / pageSize) - 1
              }
              className="p-2 bg-yellow-500 rounded-md disabled:opacity-50 hover:bg-yellow-600"
            >
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default NewUsers;
